module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "querty_content medicalRecordArea"
  }, [_c('div', [_c('div', {
    staticClass: "crumbs"
  }, [_c('span', [_vm._v("首页")]), _vm._v(">\n      "), _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'MedicalRecord'
      }
    }
  }, [_vm._v("典型病例库")])], 1), _vm._v(" >\n      "), _c('span', [_vm._v("查看详情")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "report_title"
  }, [_c('b', {
    staticClass: "caseNmae",
    attrs: {
      "title": _vm.detail.caseName
    }
  }, [_vm._v(_vm._s(_vm.detail.caseName))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.detail.caseSex))]), _vm._v(" "), _c('b', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detail.caseAge !== undefined),
      expression: "detail.caseAge !== undefined"
    }]
  }, [_vm._v(_vm._s(_vm.detail.caseAge) + _vm._s(_vm.detail.ageUnit))]), _vm._v(" "), _vm._l((_vm.detail.catalogList), function(item, index) {
    return _c('i', {
      key: index
    }, [_vm._v(_vm._s(item.catalogname))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "query_medicalRecord_left"
  }, [_c('tabs', {
    attrs: {
      "activeName": '0'
    },
    on: {
      "tabChange": _vm.tabChange
    }
  }, [_c('el-tab-pane', {
    staticClass: "p-table-text",
    attrs: {
      "name": "0"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("附件(" + _vm._s(_vm.attachList.length) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "list_title list_file_title"
  }, [_vm._v("文件类型")]), _vm._v(" "), _c('div', {
    staticClass: "query_medicalRecord_left_file_content"
  }, [(_vm.fileList.length === 0) ? _c('div', {
    staticClass: "defaultTxt"
  }, [_vm._v("暂无上传文件")]) : _c('div', _vm._l((_vm.fileList), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "file_row",
      class: {
        active: index === _vm.fileI
      },
      on: {
        "click": function($event) {
          return _vm.fileCLick('file', item, index)
        }
      }
    }, [_vm._v(_vm._s(item.attach_name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "list_title list_file_title"
  }, [_vm._v("其他图片")]), _vm._v(" "), _c('div', {
    staticClass: "query_medicalRecord_left_file_content"
  }, [(_vm.picList.length === 0) ? _c('div', {
    staticClass: "defaultTxt"
  }, [_vm._v("暂无上传图片")]) : _c('div', _vm._l((_vm.picList), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "file_row",
      class: {
        active: index === _vm.picI
      },
      on: {
        "click": function($event) {
          return _vm.fileCLick('img', item, index)
        }
      }
    }, [_vm._v(_vm._s(item.attach_name))])
  }), 0)])]), _vm._v(" "), _c('el-tab-pane', {
    staticClass: "p-table-text",
    attrs: {
      "name": "1"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("影像(" + _vm._s(_vm.studyList.length) + ")")]), _vm._v(" "), (_vm.isImage === '1') ? _c('div', [_c('div', {
    staticClass: "list_title"
  }, [_c('span', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("检查编号")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("性别")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("年龄")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("类型")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "23%",
      "text-align": "left"
    }
  }, [_vm._v("检查项目")])]), _vm._v(" "), _c('div', {
    staticClass: "query_medicalRecord_left_image_content"
  }, [(_vm.detail.studyList.length === 0) ? _c('div', {
    staticClass: "defaultTxt",
    staticStyle: {
      "line-height": "410px"
    }
  }, [_vm._v("暂无关联影像")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.detail.studyList), function(item, index) {
    return (_vm.reportShow) ? _c('div', {
      key: index,
      staticClass: "list_cell",
      class: {
        check: index == this.i
      },
      on: {
        "click": function($event) {
          return _vm._getReportInfo(item, index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v(_vm._s(item.accessionNumber))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.patientSex))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.patientAge),
        expression: "item.patientAge"
      }],
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.patientAge))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(item.examTypeName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "width": "23%",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(item.examBodyName))])]) : _vm._e()
  })], 2)]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "query_medicalRecord_right"
  }, [(_vm.isImage === '1') ? _c('div', {
    staticClass: "reportContent"
  }, [_c('h2', [_vm._v("\n            " + _vm._s(_vm.reportInfo.examTypeName) + "报告单\n            "), _c('i', {
    staticClass: "btn btn2"
  }, [_vm._v("电子病历")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.readFilmY),
      expression: "readFilmY"
    }],
    staticClass: "btn btn1",
    on: {
      "click": _vm.getImage
    }
  }, [_vm._v("阅片")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.readFilmN),
      expression: "readFilmN"
    }],
    staticClass: "btn4"
  }, [_vm._v("阅片")]), _vm._v(" "), _c('i', {
    staticClass: "btn btn3",
    on: {
      "click": _vm.getReport
    }
  }, [_vm._v("查看申请单")])]), _vm._v(" "), _c('report', {
    attrs: {
      "info": _vm.reportInfo
    }
  })], 1) : _c('div', {
    staticClass: "file_area"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailShow),
      expression: "detailShow"
    }]
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": require("../../../../static/image/defaultpic.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "23px",
      "text-align": "center"
    }
  }, [_vm._v("暂无内容")])]), _vm._v(" "), (_vm.imgShow == '1') ? _c('div', {
    staticClass: "img_area"
  }, [_c('img', {
    attrs: {
      "width": "80%",
      "src": _vm.url,
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.showBigImg()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.imgShow == '0') ? _c('div', {
    staticClass: "file_show"
  }, [_c('p', {
    staticClass: "tip"
  }, [_vm._v("暂不支持预览，请点击下载")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.url
    }
  }, [_vm._v("下载")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    staticStyle: {
      "background": "#fff",
      "padding-bottom": "20px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('h2', {
    staticClass: "label_title_h2"
  }, [_c('span'), _vm._v("| 就诊信息\n          ")])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {}, [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('span', {
    staticClass: "info_content"
  }, [_vm._v(_vm._s(_vm.detail.remark))])])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {}, [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("患者病史：")]), _vm._v(" "), _c('span', {
    staticClass: "info_content"
  }, [_vm._v(_vm._s(_vm.detail.history))])])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {}, [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("病理结果：")]), _vm._v(" "), _c('span', {
    staticClass: "info_content"
  }, [_vm._v(_vm._s(_vm.detail.caseResult))])])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {}, [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("诊断所见：")]), _vm._v(" "), _c('span', {
    staticClass: "info_content"
  }, [_vm._v(_vm._s(_vm.detail.evidence))])])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {}, [_c('span', {
    staticClass: "label_title"
  }, [_vm._v("诊断结果：")]), _vm._v(" "), _c('span', {
    staticClass: "info_content"
  }, [_vm._v(_vm._s(_vm.detail.dianogeResult))])])])], 1)], 1)]), _vm._v(" "), (_vm.repShow) ? _c('pops', {
    staticClass: "collect",
    attrs: {
      "show": _vm.repShow,
      "width": _vm.popwidth,
      "title": _vm.title,
      "classes": 'Collections'
    },
    on: {
      "closePop": _vm.closePop
    }
  }, [_c('elcRep', {
    attrs: {
      "elcRep": _vm.elcRep,
      "emergent": _vm.emergent
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.filePop) ? _c('pops', {
    class: 'mrDialog',
    attrs: {
      "show": _vm.filePop,
      "title": '',
      "width": '980px'
    },
    on: {
      "closePop": _vm.closeFile
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.url,
      "width": "100%",
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('aycanImages', {
    ref: "aycanImages",
    attrs: {
      "hospitalId": _vm.params.hospitalId,
      "studyPk": _vm.params.studyPk,
      "studyUid": _vm.params.studyUid
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-2ad0b52a","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/moudle/medicalRecord/queryMedicalRecordInfo.vue
// module id = 545
// module chunks = 1 2 3 4 5 6 7 8